import React from "react";
import ReactDOM from "react-dom";

// Global styles
import "./styles/reset.css";
import "./styles/font.css";

import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
